import { render } from "./AlertsPriority.vue?vue&type=template&id=a93cdf40&scoped=true"
import script from "./AlertsPriority.vue?vue&type=script&lang=js"
export * from "./AlertsPriority.vue?vue&type=script&lang=js"

import "./AlertsPriority.vue?vue&type=style&index=0&id=a93cdf40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a93cdf40"]])

export default __exports__